import { Stack, Typography, useTheme } from "@mui/material";
import { Minus, Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	all: boolean;
	onClick?: () => void;
};

export const ToggleAll: FC<Props> = ({ all, onClick }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			height={40}
			direction="row"
			alignItems="center"
			onClick={onClick}
			gap={0.5}
		>
			{all ? (
				<>
					<Minus color={theme.palette.primary.main} />
					<Typography
						variant="deprecatedBodyStrong"
						color={theme.palette.primary.main}
					>
						{t(Resources.Common.Hide)}
					</Typography>
				</>
			) : (
				<>
					<Plus color={theme.palette.primary.main} />
					<Typography
						variant="deprecatedBodyStrong"
						color={theme.palette.primary.main}
					>
						{t(Resources.Common.DisplayAll)}
					</Typography>
				</>
			)}
		</Stack>
	);
};
